import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import { filter, includes } from 'lodash';
import queryString from 'query-string';
import { CHILDREN_PER_PAGE } from 'constants/Values';
import * as pupilsActions from '../actions/Pupils';

import * as ecaActions from '../actions/ECA';
import * as ecaApi from '../api/ECA';
import { showErrorNotification } from '../actions/App';
import { history } from '../store';

import {
  ECA_ACTIVITY_DETAILS,
  ECA_ACTIVITY_EVENTS_PARTICIPANTS,
  ECA_ADD_ACTIVITY_LEADS,
  ECA_ADD_ACTIVITY_PARTICIPANTS,
  ECA_ADD_EVENT_COORDINATORS,
  ECA_ADD_EVENT_PARTICIPANTS,
  ECA_CREATE_ACTIVITY,
  ECA_CREATE_EVENT,
  ECA_CREATE_PROGRAM,
  ECA_DELETE_ACTIVITY,
  ECA_DELETE_ACTIVITY_LEADS,
  ECA_DELETE_ACTIVITY_PARTICIPANTS,
  ECA_DELETE_EVENT,
  ECA_DELETE_EVENT_COORDINATORS,
  ECA_DELETE_EVENT_PARTICIPANTS,
  ECA_DELETE_PROGRAM,
  ECA_EVENT_DETAILS,
  ECA_FETCH_AND_SHOW_ACTIVITY_LEADS,
  ECA_FETCH_AND_SHOW_EVENT_COORDINATORS,
  ECA_LIST_PROGRAMS,
  ECA_PROGRAM_DETAILS,
  ECA_SEARCH_EVENTS_BY_PARTICPANTS,
  ECA_TODAY_EVENTS,
  ECA_UPDATE_ACTIVITY,
  ECA_UPDATE_EVENT,
  ECA_UPDATE_PARTICIPANT_NEXT,
  ECA_UPDATE_PROGRAM,
  GET_EVENTS_HISTORY,
  GET_EVENT_HISTORY_TABS,
  GET_EVENT_HISTORY_TAB_DATA,
  SEARCH_PUPILS_FOR_EVENT,
} from '../constants/ActionTypes';
import { searchPupils } from '../api/Pupils';

// const storedProgramsSelector = state => state.eca.programs;
// const storedActivitiesSelector = state => state.eca.activities;
// const storedEventsSelector = state => state.eca.events;
const storedProgramSelector = state => state.eca.program;
const storedActivitySelector = state => state.eca.activity;
const storedEventSelector = state => state.eca.event;
const storedRegistrationsSelector = state => state.eca.activity.participants;

function* listPrograms() {
  try {
    const { data } = yield call(ecaApi.listPrograms);
    yield put(ecaActions.listProgramsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* createProgram({ payload }) {
  try {
    const { data } = yield call(ecaApi.createProgram, payload.program);
    yield put(ecaActions.createProgramSuccess(data));
    yield put(ecaActions.hideEditProgram());
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* updateProgram({ payload }) {
  try {
    const { data } = yield call(ecaApi.updateProgram, payload.program);
    yield put(ecaActions.updateProgramSuccess(data));
    yield put(ecaActions.hideEditProgram());
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* deleteProgram({ payload }) {
  try {
    yield call(ecaApi.deleteProgram, payload.programId);
    yield put(ecaActions.deleteProgramSuccess(payload.programId));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* programDetails({ payload }) {
  try {
    const { data } = yield call(ecaApi.programDetails, payload.programId);
    yield put(ecaActions.programDetailsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* createActivity({ payload }) {
  try {
    const program = yield select(storedProgramSelector);
    const { data } = yield call(ecaApi.createActivity, {
      programId: program.id,
      ...payload.activity,
    });
    yield put(ecaActions.createActivitySuccess(data));
    yield put(ecaActions.hideEditActivity());
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* updateActivity({ payload }) {
  try {
    const { data } = yield call(ecaApi.updateActivity, payload.activity);
    yield put(ecaActions.updateActivitySuccess(data));
    yield put(ecaActions.hideEditActivity());
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* deleteActivity({ payload }) {
  try {
    yield call(ecaApi.deleteActivity, payload.activityId);
    yield put(ecaActions.deleteActivitySuccess(payload.activityId));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* activityDetails({ payload }) {
  try {
    const { data } = yield call(ecaApi.activityDetails, payload.activityId);
    yield put(ecaActions.activityDetailsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* activityEventsParticipants({ payload }) {
  try {
    const { data } = yield call(ecaApi.activityEventsParticipants, payload.activityId);
    yield put(ecaActions.activityEventsParticipantsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* addActivityParticipants({ payload }) {
  try {
    const { data } = yield call(ecaApi.addActivityParticipants, payload);
    yield put(ecaActions.addActivityParticipantsSuccess(data));
    yield put(ecaActions.hideActivityParticipants());
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* deleteActivityParticipants({ payload }) {
  try {
    const { data } = yield call(ecaApi.deleteActivityParticipants, payload);
    yield put(ecaActions.deleteActivityParticipantsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* addActivityLeads({ payload }) {
  try {
    const { data } = yield call(ecaApi.addActivityLeads, payload);
    yield put(ecaActions.addActivityLeadsSuccess(data));
    yield put(ecaActions.hideAndClearActivityLeads());
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* deleteActivityLeads({ payload }) {
  try {
    const { data } = yield call(ecaApi.deleteActivityLeads, payload);
    yield put(ecaActions.deleteActivityLeadsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* fetchActivityLeads({ payload }) {
  try {
    const currentActivityDetails = yield select(storedActivitySelector);
    const isCurrentDetails =
      currentActivityDetails && payload.activityId === currentActivityDetails.id;
    if (isCurrentDetails) {
      yield put(ecaActions.fetchActivityLeadsSuccess(currentActivityDetails));
      return;
    }
    const { data } = yield call(ecaApi.activityDetails, payload.activityId);
    yield put(ecaActions.fetchActivityLeadsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* createEvent({ payload }) {
  try {
    const activity = yield select(storedActivitySelector);
    const { data } = yield call(ecaApi.createEvent, {
      activityId: activity.id,
      ...payload.event,
    });
    yield put(ecaActions.createEventSuccess(data));
    yield put(ecaActions.hideEditEvent());
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* updateEvent({ payload }) {
  try {
    const { data } = yield call(ecaApi.updateEvent, payload.event);
    yield put(ecaActions.updateEventSuccess(data, payload.propagateStateEventDetails));
    yield put(ecaActions.hideEditEvent());
    if (payload.fetchEventDetails) {
      yield put(ecaActions.eventDetails(payload.event.id));
    }
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* deleteEvent({ payload }) {
  try {
    yield call(ecaApi.deleteEvent, payload.eventId);
    yield put(ecaActions.deleteEventSuccess(payload.eventId));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* eventDetails({ payload }) {
  try {
    const detailsFunc = payload.fetchActive
      ? ecaApi.activeEventDetailsForEvent
      : ecaApi.eventDetails;
    const { data } = yield call(detailsFunc, payload.eventId);
    yield put(ecaActions.eventDetailsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* addEventParticipants({ payload }) {
  try {
    const { data } = yield call(ecaApi.addEventParticipants, payload);
    yield put(ecaActions.addEventParticipantsSuccess(data));
    yield put(ecaActions.hideEventParticipants());
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}
function* updateParticipantNext({ payload }) {
  try {
    const { data } = yield call(ecaApi.updateParticipantNext, payload);
    yield put(ecaActions.eventDetailsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* deleteEventParticipants({ payload }) {
  try {
    const { data } = yield call(ecaApi.deleteEventParticipants, payload);
    yield put(ecaActions.deleteEventParticipantsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* searchPupilsForEvent({ payload }) {
  try {
    const registrations = yield select(storedRegistrationsSelector);
    const openEnrollment = registrations.length === 0;
    if (openEnrollment) {
      const response = yield call(
        searchPupils,
        payload.filter,
        payload.selectedPupilsIds,
        CHILDREN_PER_PAGE,
      );
      yield put(pupilsActions.searchPupilsSuccess(response.data.entities));
    } else {
      const search = payload.filter.length > 0 ? payload.filter.toLowerCase() : false;
      yield put(
        pupilsActions.searchPupilsSuccess(
          filter(
            registrations,
            r =>
              !includes(payload.selectedPupilsIds, r.id) &&
              (!search || r.fullName.toLowerCase().includes(search)),
          ),
        ),
      );
    }
  } catch (error) {
    yield put(showErrorNotification(error.messages));
    yield put(pupilsActions.searchPupilsFailure());
  }
}

function* searchEventsByParticipants({ payload }) {
  try {
    const response = yield call(ecaApi.searchEventsByParticipants, payload.participantIds);
    yield put(
      ecaActions.searchEventsByParticipantsSuccess(response.data.entities, response.data.pageCount),
    );
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* addEventCoordinators({ payload }) {
  try {
    const { data } = yield call(ecaApi.addEventCoordinators, payload);
    yield put(ecaActions.addEventCoordinatorsSuccess(data));
    yield put(ecaActions.hideAndClearEventCoordinators());
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* deleteEventCoordinators({ payload }) {
  try {
    const { data } = yield call(ecaApi.deleteEventCoordinators, payload);
    yield put(ecaActions.deleteEventCoordinatorsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}
function* fetchEventCoordinators({ payload }) {
  try {
    const currentEventDetails = yield select(storedEventSelector);
    const isCurrentDetails = currentEventDetails && payload.eventId === currentEventDetails.id;
    if (isCurrentDetails) {
      yield put(ecaActions.fetchEventCoordinatorsSuccess(currentEventDetails));
      return;
    }
    const { data } = yield call(ecaApi.eventDetails, payload.eventId);
    yield put(ecaActions.fetchEventCoordinatorsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* todayEvents() {
  try {
    const { data } = yield call(ecaApi.todayEvents);
    yield put(ecaActions.todayEventsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

// ECA History Saga
function* getEventsHistorySaga({ payload }) {
  yield put(ecaActions.showEventsHistoryLoader());

  try {
    const { query, params, affectQuery } = payload;

    // Update URL with filter params if requested
    if (affectQuery && params) {
      const currentSearch = queryString.parse(window.location.search);
      const newSearch = { ...currentSearch, ...params };
      history.replace({ search: queryString.stringify(newSearch) });
    }

    const { data } = yield call(ecaApi.getEventsHistory, query);

    yield put(ecaActions.getEventsHistorySuccess(data.entities || data, data.pageCount || 1));
  } catch (error) {
    console.error('Search error:', error);
    yield put(ecaActions.getEventsHistoryFailure(error));
    yield put(showErrorNotification(error.messages));
  } finally {
    yield put(ecaActions.hideEventsHistoryLoader());
  }
}

// ECA History Tabs Saga
function* getEventHistoryTabsSaga() {
  try {
    const { data } = yield call(ecaApi.getEventHistoryTabs);

    console.log('=== TABS RESPONSE ===', data); // INSPECT DATA HERE

    // Handle different possible response structures
    const tabs = data.tabs || data;
    yield put(ecaActions.getEventHistoryTabsSuccess(tabs));
  } catch (error) {
    console.error('Tabs error:', error);
    yield put(ecaActions.getEventHistoryTabsFailure(error));
    yield put(showErrorNotification(error.messages));
  }
}

// ECA History Tab Data Saga
function* getEventHistoryTabDataSaga({ payload }) {
  try {
    const { eventId, tabPath, query } = payload;
    const { data } = yield call(ecaApi.getEventHistoryTabData, eventId, tabPath, query);

    console.log(`=== TAB DATA RESPONSE (${tabPath}) ===`, data); // INSPECT DATA HERE

    yield put(ecaActions.getEventHistoryTabDataSuccess(tabPath, data));
  } catch (error) {
    console.error('Tab data error:', error);
    yield put(ecaActions.getEventHistoryTabDataFailure(payload.tabPath, error));
    yield put(showErrorNotification(error.messages));
  }
}

export function* searchPupilsForEventSaga() {
  yield takeLatest(SEARCH_PUPILS_FOR_EVENT, searchPupilsForEvent);
}
export default function* rootSaga() {
  yield all([
    takeLatest(ECA_CREATE_PROGRAM, createProgram),
    takeLatest(ECA_UPDATE_PROGRAM, updateProgram),
    takeLatest(ECA_DELETE_PROGRAM, deleteProgram),
    takeLatest(ECA_LIST_PROGRAMS, listPrograms),
    takeLatest(ECA_PROGRAM_DETAILS, programDetails),
    takeLatest(ECA_CREATE_ACTIVITY, createActivity),
    takeLatest(ECA_UPDATE_ACTIVITY, updateActivity),
    takeLatest(ECA_DELETE_ACTIVITY, deleteActivity),
    takeLatest(ECA_ACTIVITY_DETAILS, activityDetails),
    takeLatest(ECA_ACTIVITY_EVENTS_PARTICIPANTS, activityEventsParticipants),
    takeLatest(ECA_CREATE_EVENT, createEvent),
    takeLatest(ECA_UPDATE_EVENT, updateEvent),
    takeLatest(ECA_DELETE_EVENT, deleteEvent),
    takeLatest(ECA_EVENT_DETAILS, eventDetails),
    takeLatest(ECA_ADD_ACTIVITY_PARTICIPANTS, addActivityParticipants),
    takeLatest(ECA_DELETE_ACTIVITY_PARTICIPANTS, deleteActivityParticipants),
    takeLatest(ECA_ADD_EVENT_PARTICIPANTS, addEventParticipants),
    takeLatest(ECA_DELETE_EVENT_PARTICIPANTS, deleteEventParticipants),
    takeLatest(ECA_UPDATE_PARTICIPANT_NEXT, updateParticipantNext),
    takeLatest(ECA_ADD_ACTIVITY_LEADS, addActivityLeads),
    takeLatest(ECA_DELETE_ACTIVITY_LEADS, deleteActivityLeads),
    takeLatest(ECA_FETCH_AND_SHOW_ACTIVITY_LEADS, fetchActivityLeads),
    takeLatest(ECA_ADD_EVENT_COORDINATORS, addEventCoordinators),
    takeLatest(ECA_DELETE_EVENT_COORDINATORS, deleteEventCoordinators),
    takeLatest(ECA_FETCH_AND_SHOW_EVENT_COORDINATORS, fetchEventCoordinators),
    takeLatest(ECA_TODAY_EVENTS, todayEvents),
    takeLatest(ECA_SEARCH_EVENTS_BY_PARTICPANTS, searchEventsByParticipants),
    takeLatest(GET_EVENTS_HISTORY, getEventsHistorySaga),
    takeLatest(GET_EVENT_HISTORY_TABS, getEventHistoryTabsSaga),
    takeLatest(GET_EVENT_HISTORY_TAB_DATA, getEventHistoryTabDataSaga),
    fork(searchPupilsForEventSaga),
  ]);
}
